import React, { Component, Fragment } from "react";
import { Col, Container, Row, Modal, Image } from "react-bootstrap";

import Paper from "@material-ui/core/Paper";
import InputBase from "@material-ui/core/InputBase";
import IconButton from "@material-ui/core/IconButton";

import { makeStyles } from "@material-ui/core/styles";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import {
  create_order_vedor_side,
  razor_pay_create_order,
  razor_payment,
  credit_memo_substitute_item,
  substitute_items,
  debit_memo_order_substitute_item,
  apply_offer_code,
  // edit_location,
  editTransaction,
} from "../../../../store/actions/OrderingAction/vendorOrderingAction";
import { get_offers_details } from "../../../../store/actions/vendorOffersAndEventsAction";
import store from "../../../../store/store";
import Alert from "react-s-alert";
import { APPLY_OFFER_VENDOR, CLEAR_CART_DATA, CREATE_ORDER_VENDOR, } from "../../../../store/types";
import { ORDER_RAZORPAY_KEY } from "../../../../config/Keys";
import { getPendingPayment } from "../../../../function/getPendingPayment";
import isEmpty from "../../../../store/validation/is-Empty";
import InfoToolTip from "../../../reusableComponents/InfoTooltipComponent";
import { ITEMTYPEVEG } from "../../../../enums/OrderEnums";
import { errorAlert } from "../../../../function/alert";
import {
  calcFinalTotal,
  calcTotalOriginal,
  calcTotalOriginalEdit,
  splitTaxesEdit,
  calcDiscount
} from "../../../../function/ordering";
import VendorLearnMore from "../../../reusableComponents/allPopupReusable/learnMorePopup/VendorLearnMore";
import { NewInputText } from "../../../reusableComponents/inputReusableComponent/InputBoxComponent";
import SimpleReactLightbox, { SRLWrapper } from "simple-react-lightbox";
import { useState } from "react";
import { useEffect } from "react";
import { amApi } from "../../../../api/apiHelper";

const tips = [
  { id: 0, amount: 0, title: "None" },
  { id: 1, amount: 5, title: "5" },
  { id: 2, amount: 10, title: "10" },
  { id: 3, amount: 15, title: "15" },
  // { id: 4, title: "Custom" },
];

const donates = [
  { id: 0, amount: 0, title: "None" },
  { id: 1, amount: 2, title: "2" },
  { id: 2, amount: 5, title: "5" },
  { id: 3, amount: 10, title: "10" },
  // { id: 4, amount: 40 },
  // { id: 5, amount: 50 },
  // { id: 6, amount: 100 },
  // { id: 4, title: "Custom" },
];

const optionsImage = {
  settings: {
    autoplaySpeed: 3000,
    disableKeyboardControls: false,
    disablePanzoom: false,
    disableWheelControls: false,
    hideControlsAfter: 3000,
    lightboxTransitionSpeed: 0.6,
    lightboxTransitionTimingFunction: "linear",
    overlayColor: "rgba(0, 0, 0, 0.9)",
    slideAnimationType: "fade",
    slideSpringValues: [300, 200],
    slideTransitionSpeed: 0.6,
    slideTransitionTimingFunction: "linear",
  },
  buttons: {
    showAutoplayButton: false,
    showCloseButton: true,
    showDownloadButton: false,
    showFullscreenButton: false,
    showNextButton: false,
    showPrevButton: false,
    showThumbnailsButton: false,
  },
  caption: {
    showCaption: false,
  },
  thumbnails: {
    showThumbnails: false,
  },
  progressBar: {
    showProgressBar: false,
  },
};

const useStyles = makeStyles((theme) => ({
  root: {
    padding: "2px 4px",
    display: "flex",
    alignItems: "center",
    width: "100%",
    border: "0.5px solid #9E9E9E;",
    borderRadius: "5px",
  },
  input: {
    marginLeft: theme.spacing(1),
    flex: 1,
  },
  iconButton: {
    padding: 10,
  },
  divider: {
    height: 28,
    margin: 4,
  },
  chip: {
    margin: theme.spacing(0.5),
  },
}));

const InputPromotion = (props) => {
  const classes = useStyles();

  const [offerCode, setOfferCode] = useState("");

  useEffect(() => {
    if (props && props.offer_code && props.offer_code.isOfferApplied) {
      setOfferCode(props.offer_code.coupon_code);
    }
  }, [props.offer_code.isOfferApplied]);

  const removeOffer = () => {
    const formData = {};
    formData.isOfferApplied = false;
    store.dispatch({
      type: APPLY_OFFER_VENDOR,
      payload: formData,
    });
  };

  return (
    <React.Fragment>
      <div>
        <Paper className={classes.root}>
          <InputBase
            disabled={
              props && props.offer_code && props.offer_code.isOfferApplied
            }
            className={classes.input}
            placeholder="Write Here"
            inputProps={{ "aria-label": "Write Here" }}
            value={offerCode.toUpperCase()}
            onChange={(e) => setOfferCode(e.currentTarget.value)}
          />
          <IconButton
            className={classes.iconButton}
            aria-label="apply"
            onClick={() => {
              if (offerCode === "") {
                Alert.error(`<h4>Enter Coupon Code</h4>`, {
                  position: "top-right",
                  effect: "bouncyflip",
                  beep: true,
                  html: true,
                  timeout: 3000,
                  offset: 35,
                });
              } else {
                props && props.offer_code && props.offer_code.isOfferApplied
                  ? removeOffer()
                  : props.apply_offer(offerCode);
              }
            }}
          >
            <button
              className="btn"
              style={{
                backgroundColor: "#2196F3",
                color: "#ffffff",
                borderRadius: "15px",
                boxShadow: "0px 5px 8px #6E6E6E57",
              }}
            >
              {props && props.offer_code && props.offer_code.isOfferApplied
                ? "Remove"
                : "Apply"}
            </button>
          </IconButton>
        </Paper>
      </div>
    </React.Fragment>
  );
};

class RightComponentOrderRequestSubstitute extends Component {
  state = {
    tip: 0,
    tipAmount: 0,
    totalTipAmount: 0,
    discount: 0,
    open: false,
    openTract: false,
    total_amount: 0,
    donationId: 1,
    donationAmount: 2,
    total_charges: 0,
    open_memo_modal: false,
    create_memo: false,
    availableOffers: [],
    displayAvailableOffers: false,
    newItems: [],
    cartData: {},
    subData: {},
    allData: {},
  };

  componentDidMount() {
    let subTaxes = splitTaxesEdit(
      this.props.item,
      this.props.user_data,
      this.props.subscription
    );
    let subTotal = calcTotalOriginalEdit(this.props.item);
    let subData = {
      base: subTotal,
      taxes: subTaxes,
      total:
        Number(subTotal) +
        Number(subTaxes.gstTotal) +
        Number(subTaxes.surTotal),
    };
    this.setState({ subData: subData });
  }

  static getDerivedStateFromProps(nextProps, nextState) {
    if (!isEmpty(nextProps.item) && !isEmpty(nextProps.cart_data)) {
      let subTaxes = splitTaxesEdit(
        nextProps.item,
        nextProps.user_data,
        nextProps.subscription
      );
      let subTotal = calcTotalOriginalEdit(nextProps.item);
      let subData = {
        base: subTotal,
        taxes: subTaxes,
        total:
          Number(subTotal) +
          Number(subTaxes.gstTotal) +
          Number(subTaxes.surTotal),
      };
      let cartTaxes = splitTaxesEdit(
        nextProps.cart_data,
        nextProps.user_data,
        nextProps.subscription
      );
      let cartTotal = calcTotalOriginalEdit(nextProps.cart_data);
      let cartData = {
        base: cartTotal,
        taxes: cartTaxes,
        total:
          Number(cartTotal) +
          Number(cartTaxes.gstTotal) +
          Number(cartTaxes.surTotal),
      };
      let itemId = nextProps.item.map((e) => e._id);
      let itemData = [];
      itemData = nextProps.user_data?.order_items.filter(
        (e) => !itemId.includes(e._id) || e.isSubstituted || e.isCancelled
      );
      let cart = nextProps.cart_data.flat();
      itemData = [...itemData, ...cart];

      let allData = calcFinalTotal(
        itemData,
        nextProps.user_data,
        [nextProps?.history?.location?.state?.offerCode || nextState.offerCodeData],
        nextProps.subscription
      );
      allData.baseTotal = calcTotalOriginalEdit(itemData);
      let pending = Number(getPendingPayment(nextProps.user_data) || 0);
      // allData.settleAmount = Number(cartData.total - subData.total).toFixed(2);
      allData.revised = Number(
        Number(allData.total) -
        (Number(nextProps.user_data?.total_amount)).toFixed(2)
      );
      allData.pending = pending;
      allData.revisedTotal = (
        // Number(allData.settleAmount) +
        Number(allData.revised) +
        Number(pending)
      ).toFixed(2);
      return { subData: subData, cartData: cartData, allData: allData, tipAmount: nextProps.user_data?.tip?.amount, tip: nextProps.user_data?.tip?.value };
    }
  }

  componentDidUpdate(prevProps) {
    if (
      JSON.stringify(prevProps.cart_data) !==
      JSON.stringify(this.props.cart_data) || JSON.stringify(prevProps.user_data) !==
      JSON.stringify(this.props.user_data)
    ) {
      let cartTaxes = splitTaxesEdit(
        this.props.cart_data,
        this.props.user_data,
        this.props.subscription
      );
      let cartTotal = calcTotalOriginalEdit(this.props.cart_data);
      let cartData = {
        base: cartTotal,
        taxes: cartTaxes,
        total:
          Number(cartTotal) +
          Number(cartTaxes.gstTotal) +
          Number(cartTaxes.surTotal),
      };
      let itemId = this.props.item.map((e) => e._id);
      let itemData = [];
      itemData = this.props.user_data?.order_items.filter(
        (e) => !itemId.includes(e._id) || e.isSubstituted || e.isCancelled
      );
      let cart = this.props.cart_data.flat();
      itemData = [...itemData, ...cart];
      let allData = calcFinalTotal(
        itemData,
        this.props.user_data,
        [this.props?.history?.location?.state?.offerCode || this.state.offerCodeData],
        this.props.subscription
      );
      let discount = calcDiscount(itemData, this.props.user_data, [this.props?.history?.location?.state?.offerCode || this.state.offerCodeData]);
      let pending = Number(getPendingPayment(this.props.user_data) || 0);
      // allData.settleAmount = Number(
      //   cartData.total - this.state.subData.total
      // ).toFixed(2);
      allData.revised = Number(
        Number(allData.total) -
        (
          Number(this.props.user_data?.total_amount)
          // + Number(allData.settleAmount)
        ).toFixed(2)
      );
      allData.pending = pending;
      allData.revisedTotal = (
        // Number(allData.settleAmount) +
        Number(allData.revised) +
        Number(pending)
      ).toFixed(2);
      this.setState({ cartData: cartData, allData: allData, discount: discount });
    }
  }

  setOpenTract = () => {
    this.setState({ open: false, openTract: true });
  };

  calcAllCharges = (data) => {
    let itemPrice = 0;
    let addOns = 0;

    itemPrice = data?.size?.price * data?.quantity;

    for (let i = 0; i < data.addOns.length; i++) {
      for (let j = 0; j < data.addOns[i].options.length; j++) {
        addOns =
          addOns + parseInt(data.addOns[i].options[j]?.price) * data.quantity;
      }
    }

    return itemPrice + addOns;
  };


  getTotal = () => {
    let newData = [];
    let oldData = [];

    oldData = this.props.user_data?.order_items.filter(
      (e) => !e.isCancelled && !e.isSubstituted
    );
    oldData = [...oldData, ...this.props.item];
    newData = this.props.user_data?.order_items.filter(
      (e) => !e.isSubstituted && !e.isCancelled
    );
    newData = [...newData, ...this.props?.cart_data.flat()];
    let oldPrice = calcFinalTotal(oldData);
    let newPrice = calcFinalTotal(newData);
    return (newPrice - oldPrice).toFixed(2);
  };

  onSuccess = () => {
    this.props.history.push("/orderdashboard");
  };

  loadScript = (src) => {
    return new Promise((resolve) => {
      const script = document.createElement("script");
      script.src = src;
      script.onload = () => {
        resolve(true);
      };
      script.onerror = () => {
        resolve(false);
      };
      document.body.appendChild(script);
    });
  };

  callDebitMemo = (amount) => {
    const formData = {};
    formData.amount = amount * -1;
    formData.order_id = this.props.substitute_existing_record._id;
    formData.items = [];
    let subsData = [...this.props.item];

    for (let i = 0; i < subsData.length; i++) {
      subsData[i].isSubstituted = true;

      formData.items.push(subsData[i]);
    }

    formData.items = [...formData.items, ...this.props.cart_data.flat()];


    let paidAmount = 0;
    for(let txn of this.props.substitute_existing_record?.transactionDetails){
      if (txn.paid && txn.type === 'PAYMENT' && ['RAZORPAY', 'WALLET'].includes(txn.method)) {
        paidAmount += txn.amount;
      }
    }

    if (this.props.substitute_existing_record.payment_status === 1 && paidAmount > 0) {
      const token = this.props.auth.user.accessToken;
      this.props.debit_memo_order_substitute_item(
        token,
        formData,
        this.onSuccessCallItemSubstitute
      );
    } else {
      this.onSuccessCallItemSubstitute();
    }
  };

  decidePayment = (payment) => {
    this.setState({ create_memo: true });
    if (this.state.allData?.revised < 0) {
      let orderData = {
        id: this.props.substitute_existing_record._id,
        paid: true,
        amount: this.state.allData?.revised,
        type: "REFUND",
        date: Date.now(),
      };
      this.props.editTransaction(orderData);
      this.callDebitMemo(this.state.allData?.revised);
    } else if (!payment) {
      this.props.history.push("/orderpaymentsubstitute", { hideTips: true, hideOffer: true, allData: this.state.allData, offerCode: this.state.offerCodeData, discount: this.state.discount, tips: this.state.tipAmount });
    } else {
      this.onClickProceed();
    }
  };

  onSuccessRedirect = () => {
    Alert.success(`<h4>Item Substituted  Successfully</h4>`, {
      position: "top-right",
      effect: "bouncyflip",
      beep: true,
      html: true,
      timeout: 3000,
      offset: 35,
    });
    store.dispatch({
      type: CLEAR_CART_DATA,
      //payload: formData,
    });
    this.props.history.push("/orderdashboard");
  };

  onSuccessCallItemSubstitute = (memoId) => {
    const formData = {};
    formData.memoId = memoId;
    formData.order_id = this.props.substitute_existing_record._id;
    let subsData = [...this.props.item];
    let subItemId = subsData.map((ele) => ele._id);

    formData.total_amount = this.state?.allData?.total;
    let orderItems = this.props.user_data.order_items.map((ele) => {
      if (subItemId.includes(ele._id)) {
        ele.isSubstituted = true;
        return ele;
      } else return ele;
    });

    formData.gstAmount = this.state?.allData?.taxes?.gst;
    formData.surCharges = this.state?.allData?.taxes?.surCharges;
    formData.base_amount = this.state?.allData?.baseTotal;
    formData.tip = { value: this.props?.history?.location?.state?.tips || this.state.tip, amount: this.props?.history?.location?.state?.tips || this.state.tipAmount }
    formData.discount = { value: this.state.discount, amount: this.state.discount }
    formData.offer = this.state.offerCodeData?._id;
    formData.offerSettlement = this.state.offerCodeData?.settlementType

    let orderData = {
      id: this.props.substitute_existing_record._id,
      paid: true,
      amount: (this.state.allData.revised).toFixed(2),
      method:
        this.props.user_data?.payment_method === 6 ? "PAYLATER" : "EXTERNAL",
      type: this.props.user_data?.payment_method === 6 ? "PAYLATER" : "PAYMENT",
      date: Date.now(),
      paymentType: this.props.user_data?.payment_method,
    };

    if (this.props.user_data?.payment_method === 8) {
      orderData.transactionRef = this.props.user_data.walletDetails;
    }

    this.props.editTransaction(orderData);
    formData.order_items = [...orderItems, ...this.props.cart_data.flat()];

    const token = this.props.auth.user.accessToken;

    this.props.substitute_items(token, formData, this.onSuccessRedirect);
  };

  onSuccessCallDebitMemoApi = (id) => {
    const formData = {};
    formData.memoId = id._id;
    formData.order_id = this.props.substitute_existing_record._id;
    formData.items = [];
    let subsData = [...this.props.item];

    for (let i = 0; i < subsData.length; i++) {
      subsData[i].isSubstituted = true;

      formData.items.push(subsData[i]);
    }
    // for (let i = 0; i < this.props.cart_data.length; i++) {
    //   formData.items.push(this.props.cart_data[i][0]);
    // }
    formData.items = [...formData.items, ...this.props.cart_data.flat()];
    const token = this.props.auth.user.accessToken;
    this.props.credit_memo_substitute_item(
      token,
      formData,
      this.onSuccessCallItemSubstitute
    );
  };

  async displayRazorpay(total, userId, name, phoneNo, email, orderId, method) {
    const res = await this.loadScript(
      "https://checkout.razorpay.com/v1/checkout.js"
    );

    if (!res) {
      alert("Razorpay SDK failed to load. Are you online?");
      return;
    }

    const onSuccess = (data, orderId) => {
      this.setState({
        transactional_id: data.transactional._id,
        orderId: orderId,
      });
      // console.log("****STart*********");
      // console.log(this.state.transactional._id);
      // console.log(data.transactional._id);
      // console.log("****End*********");

      const onSuccessHandler = (response) => {
        let orderData = {
          id: this.props.substitute_existing_record._id,
          paid: true,
          transactionId: data.transactional._id,
          txnId: data?.transactional?.transactionNumber,
          method: "RAZORPAY",
          amount: total,
          type: "PAYMENT",
          date: Date.now(),
          paymentType: method,
        };
        this.props.editTransaction(orderData);

        const formData = {
          razorpay_payment_id: response.razorpay_payment_id,
          transactional_id: data.transactional._id,
          order_id: this.props.substitute_existing_record._id,
          isEvent: false,
        };
        const token = this.props.auth.user.accessToken;
        this.props.razor_payment(
          token,
          formData,
          this.onSuccessCallDebitMemoApi,
          orderId
        );
      };

      const onFailure = (response) => {
        let orderData = {
          id: this.props.substitute_existing_record._id,
          paid: false,
          transactionId: data.transactional._id,
          txnId: data?.transactional?.transactionNumber,
          method: "RAZORPAY",
          amount: total,
          type: "PAYMENT",
          date: Date.now(),
          paymentType: method,
        };
        this.props.editTransaction(orderData);

        const formData = {};
        //formData.transactional_id = data._id;
        formData.payment_status = 3;
        formData.transactional_id = data.transactional._id;
        formData.razorpay_payment_id = response.error.metadata.payment_id;
        const token = this.props.auth.user.accessToken;
        this.props.edit_order_vendor_side_payment(token, formData, orderId);
      };
      const options = {
        //key: __DEV__ ? "rzp_test_7P1z0w07gah1Uv" : "PRODUCTION_KEY",
        key: ORDER_RAZORPAY_KEY,
        currency: data.currency,
        amount: data.amount.toString(),
        order_id: data.id,
        name: "Amealio",
        description: "Amealio Ordering Payment",
        method: {
          netbanking: false,
          card: true,
          wallet: false,
          upi: false,
        },
        // config: {
        //   hide: [
        //     {
        //       method: "upi",
        //     },
        //   ],
        // },
        //image: "http://localhost:1337/logo.svg",
        handler: function (response) {
          // alert(response.razorpay_payment_id);
          // alert(response.razorpay_order_id);
          // alert(response.razorpay_signature);

          // const formData = {
          //   razorpay_payment_id: response.razorpay_payment_id,
          //   transactional_id: this.state.transactional_id,
          //   isEvent: false,
          // };
          // this.props.razor_payment(
          //   this.state.token,
          //   formData,
          //   this.onSuccessCallFinalApi
          // );
          onSuccessHandler(response);
        },
        prefill: {
          name: name,
          email: email,
          contact: phoneNo,
        },
      };
      const paymentObject = new window.Razorpay(options);
      paymentObject.open();
      paymentObject.on("payment.failed", function (response) {
        onFailure(response);
        // alert(response.error.code);
        // alert(response.error.description);
        // alert(response.error.source);
        // alert(response.error.step);
        // alert(response.error.reason);
        // alert(response.error.metadata.order_id);
        // alert(response.error.metadata.payment_id);
      });
    };

    const formData = {
      amount: parseFloat(total).toFixed(2),
      user_id: userId,
      refModel: "User",
      message: "Substitute Item",
      currency: "INR",
      isEvent: false,
      receipt: orderId,
      orderId: orderId,
      restaurant_id: this.props.onboarding._id,
      transaction_type: "RAZORPAY",
    };

    const token = this.props.auth.user.accessToken;
    this.setState({ token: token });
    this.props.razor_pay_create_order(token, formData, onSuccess, orderId);

    // const data = await fetch("http://localhost:1337/razorpay", {
    //   method: "POST",
    // }).then((t) => t.json());

    // console.log(data);
  }

  onClickProceed = () => {
    const formData = this.props.user_data;

    // External Wallet Validation
    if (formData.payment_method === 8 && !formData.walletDetails) {
      errorAlert("Please Enter Transaction Details");
      return;
    }
    console.log('this.state.allData, this.props.history.location.allData', this.state.allData, this.props.history.location.allData)
    if (
      formData.payment_method === 0 ||
      formData.payment_method === 6 ||
      formData.payment_method === 9 ||
      formData.payment_method === 8
    ) {
      this.onSuccessCallItemSubstitute();
    } else {
      this.displayRazorpay(
        'diff_amount',
        formData.user_id,
        formData.user_details.first_name,
        formData.user_details.mobile_number,
        formData.user_details.email,
        this.props.substitute_existing_record._id,
        formData.payment_method
      );
    }
  };

  openCreateModal = () => {
    this.setState({ open_memo_modal: !this.state.open_memo_modal });
  };

  setDonation = (donId, donAmount) => {
    this.setState({ donationId: donId, donationAmount: donAmount });
    // let data = { ...this.props.user_data };
    // data.donation = { value: donId, amount: donAmount };
    // store.dispatch({ type: CREATE_ORDER_VENDOR, payload: data });
  };

  setTips = (tipId, tipValue) => {
    this.setState({ tip: tipId, tipAmount: tipValue });
    let data = { ...this.props.user_data };
    data.tip = { value: tipId, amount: tipValue };
    store.dispatch({ type: CREATE_ORDER_VENDOR, payload: data });
    // this.props.addTips(calcTips);
  };

  onClickAvailableOffer = async () => {
    let offers = []
    if (this.state.availableOffers <= 0) {
      offers = await amApi.get("offer/details?validOffers=true");
    }
    this.setState({
      availableOffers: offers?.status === 200 ? offers?.data : [],
      displayAvailableOffers: !this.state.displayAvailableOffers,
    });
  };

  checkAndApplyOffer = (code) => {
    let formData = { offerData: this.state.offerCodeData, offer: this.state.offerCodeData?._id }
    store.dispatch({
      type: APPLY_OFFER_VENDOR,
      payload: formData
    })
    let itemData = [];
    let itemId = this.props.item.map((e) => e._id);
    itemData = this.props.user_data?.order_items.filter(
      (e) => !itemId.includes(e._id) || e.isSubstituted || e.isCancelled
    );
    let cart = this.props.cart_data.flat();
    itemData = [...itemData, ...cart];
    let allData = calcFinalTotal(
      itemData,
      this.props.user_data,
      [this.props.offerCodeData],
      this.props.subscription
    );
    const token = this.props.auth.user.accessToken;
    const vendorId = this.props.auth.user.VendorUser._id;
    let queryData = {
      vendor_id: vendorId,
      coupon_code: code,
      user_id: this.props?.user_data?.user_details?.userId,
      order_amount: allData.total,
    };

    if (this.state?.offerCodeData?.isPercentage === false) {
      if (
        parseInt(allData.total) >= this.state?.offerCodeData?.minimum_order_applied &&
        parseInt(allData.total) <= this.state?.offerCodeData?.maximum_order_applied
      ) {
        this.props.apply_offer_code(
          token,
          queryData,
          this.onSuccessCupon,
          (err) => this.onFailureCoupon(err)
        );
      } else {
        Alert.error(
          `<h4>Offer code not apply because item price is ${parseInt(allData.total) >= this.state?.offerCodeData?.minimum_order_applied ? "more" : "less"} than offer price</h4>`,
          {
            position: "top-right",
            effect: "bouncyflip",
            beep: true,
            html: true,
            timeout: 3000,
            offset: 35,
          }
        );
      }
    } else if (this.state?.offerCodeData?.isPercentage === true) {
      if (
        parseInt(allData.total) >= this.state?.offerCodeData?.minimum_order_applied &&
        parseInt(allData.total) <= this.state?.offerCodeData?.maximum_order_applied
      ) {
        this.props.apply_offer_code(
          token,
          queryData,
          this.onSuccessCupon,
          (err) => this.onFailureCoupon(err)
        );
      } else {
        Alert.error(
          `<h4>Offer code not apply because item price is ${parseInt(allData.total) >= this.state?.offerCodeData?.minimum_order_applied ? "more" : "less"} than offer price</h4>`,
          {
            position: "top-right",
            effect: "bouncyflip",
            beep: true,
            html: true,
            timeout: 3000,
            offset: 35,
          }
        );
      }
    }
  };

  onSuccessCupon = () => {
    Alert.success(`<h4>Offer applied sucessfully</h4>`, {
      position: "top-right",
      effect: "bouncyflip",
      beep: true,
      html: true,
      timeout: 3000,
      offset: 35,
    });
  };

  onFailureCoupon = (err) => {
    Alert.error(`<h4>${err?.response?.data?.message}</h4>`, {
      position: "top-right",
      effect: "bouncyflip",
      beep: true,
      html: true,
      timeout: 3000,
      offset: 35,
    });
  };

  copyFunction = (data) => (e) => {
    let offerData = {};
    offerData._id = data?._id;
    offerData.isPercentage = data?.isPercentage;
    offerData.coupon_code = data?.coupon_code;
    offerData.discount = data?.discount;
    offerData.maximum_discount_applied = data?.maximum_discount_applied;
    offerData.maximum_order_applied = data?.maximum_order_applied;
    offerData.maximum_usage_limit = data?.maximum_usage_limit;
    offerData.minimum_order_applied = data?.minimum_order_applied;
    this.setState({
      offerCodeData: offerData,
    });
    navigator.clipboard.writeText(data?.coupon_code);
    Alert.success(`<h4>Coupon code copied</h4>`, {
      position: "top-right",
      effect: "bouncyflip",
      beep: true,
      html: true,
      timeout: 3000,
      offset: 35,
    });
  };

  render() {
    const { cart, payment } = this.props;

    if (this.props.item.length === 0) {
      this.props.history.push("/orderdashboard");
    }

    const { open, openTract, subData, cartData, allData, tip, donationId } = this.state;

    return (
      <Container fluid>
        {cart !== 0 && (
          <div>
            <h6>
              {" "}
              {!this.props.payment && !this.props.cart
                ? "Old Item Details"
                : "Old Item Details"}
            </h6>

            {this &&
              this.props &&
              this.props.item &&
              this.props.item.map((item, index) => (
                <Fragment key={index}>
                  <div className="row f10-400" style={{ marginTop: "30px" }}>
                    <Col md={3}>
                      <img
                        src={item && item.item.images[0]}
                        width="60px"
                      // width="100%"
                      />
                    </Col>
                    <Col md={7}>
                      <h6>
                        {ITEMTYPEVEG.map((type, index) => {
                          return (
                            <React.Fragment key={index}>
                              {item?.item?.itemType === type?.value ? (
                                <Image
                                  width="15px"
                                  height="15px"
                                  src={type.url}
                                  alt={type.title}
                                  title={type.title}
                                  fluid
                                />
                              ) : null}
                            </React.Fragment>
                          );
                        })}
                        {/* <img
                          src={
                            item && item.item && item.item.veg
                              ? require("../../../../assets/images/superadmin/ordericon/veg.svg")
                              : require("../../../../assets/images/superadmin/ordericon/non veg.svg")
                          }
                          width="15px"
                          heigth="15px"
                        /> */}{" "}
                        {item && item.item && item.item.name}{" "}
                        {item && item.quantity}
                        {/* {item[0].item.name} {item[0].quantity} */}
                      </h6>
                      {/* {item[0].size.description} */}
                      {item && item.size && item.size.description}
                      <p style={{ color: "#EE3A23  " }}>Customized</p>
                      <p>
                        Crust: New Hand Tossed Add On: Onion, Capsicum, Mushroom
                        {/* {this.prepareAddOn(this.props.item)} */}
                      </p>
                    </Col>
                    <Col md={2}>
                      <h6>₹ {this.calcAllCharges(item)}</h6>
                    </Col>
                  </div>
                  <hr />
                </Fragment>
              ))}

            {/* {this.props.displayActionTwo === "AddNewEditItem" ? (
                <h6 className="f18-700">Additional Items</h6>
              ) :  */}


            {this.props.cart_data.length > 0 ? (
              <h6 className="f18-700">Substitute Item Selected</h6>
            ) : (
              <> </>
            )}

            {this.props.cart_data.map((item, index) => (
              <Fragment key={index}>
                <div className="row f10-400" style={{ marginTop: "30px" }}>
                  <Col md={3}>
                    <img
                      src={item[0] && item[0].item && item[0].item.images[0]}
                      width="60px"
                    // width="100%"
                    />
                  </Col>
                  <Col md={7}>
                    <h6>
                      {ITEMTYPEVEG.map((type, index) => {
                        return (
                          <React.Fragment key={index}>
                            {item && item[0]?.itemType === type?.value ? (
                              <Image
                                width="15px"
                                height="15px"
                                src={type.url}
                                alt={type.title}
                                title={type.title}
                                fluid
                              />
                            ) : null}
                          </React.Fragment>
                        );
                      })}
                      {/* <img
                        src={
                          item[0].veg
                            ? require("../../../../assets/images/superadmin/ordericon/veg.svg")
                            : require("../../../../assets/images/superadmin/ordericon/non veg.svg")
                        }
                        width="15px"
                        heigth="15px"
                      /> */}{" "}
                      {/* {item.item.name} */}
                      {item[0].item.name} {item[0].quantity}
                    </h6>
                    {item[0].size.description}
                    <p style={{ color: "#EE3A23  " }}>Customized</p>
                    <p>
                      Crust: New Hand Tossed Add On: Onion, Capsicum, Mushroom
                    </p>
                  </Col>
                  <Col md={2}>
                    <h6>₹ {item[0].finalPrice * item[0].quantity}</h6>
                  </Col>
                </div>
                <hr />
              </Fragment>
            ))}


            {!this.props.history?.location?.state?.hideTips && <Fragment>
              <div style={{ backgroundColor: "#F8F8F8" }}>
                <div
                  // style={{
                  //   paddingTop: "10px",
                  //   paddingLeft: "10px",
                  // }}
                  className="d-flex justify-content-between pt-2 px-3 align-items-center"
                >
                  <h6>Add Tip</h6>{" "}
                  <VendorLearnMore
                    heading="Add Tip"
                    paragraphText={
                      <>
                        Tips: Terms and Conditions <br /> <br />{" "}
                        A Customer may at its sole discretion add a
                        certain amount as “Tip” for the services
                        provided through the Amealio Platform.{" "}
                        <br /> <br /> Any amount received towards
                        Tips shall be non-refundable except in the
                        following circumstances:
                        <br /> <br /> a) Order is auto-cancelled
                        before the acceptance of the order by the
                        Merchant. <br /> <br /> b) If the Order is
                        cancelled by the Merchant due to reasons
                        such as non-availability of food items
                        ordered by the Customer, non – availability
                        of the service, or any other reasons
                        attributable to the Merchant. However, in
                        case of partial cancellation or
                        modifications in the Order/Booking, the
                        amount contributed towards Tips shall be
                        non-refundable.
                        <br /> <br /> Amealio reserves the right, at
                        its sole discretion, to refuse the refund of
                        amount paid towards Tips for any reason
                        whatsoever, without assigning any reason to
                        the Customer and the Customer accepts and
                        undertakes to not raise any dispute on the
                        same. <br /> <br />
                      </>
                    }
                  />
                </div>
                <br />
                <Row
                  // style={{ marginLeft: "3%" }}
                  className="superadmin-orderscomponent-main f12-400 px-3"
                >
                  {tips.map((data, index) => {
                    return (
                      <React.Fragment key={index}>
                        <Col
                          xs={4}
                          sm={4}
                          md={4}
                          align="center"
                          onClick={() =>
                            this.setTips(data.id, data.amount)
                          }
                          key={data.id}
                        >
                          <div
                            className={`take-away-order-select d-flex f12-500 justify-content-center
                                  ${tip === data.id &&
                              `take-away-order-select-selected`
                              }`}
                            style={{
                              padding: "10px",
                              // marginRight: "12%",
                              marginBottom: "8%",
                            }}
                          >
                            {data.title === "None" ? (
                              ""
                            ) : (
                              <p style={{ color: "#ee3a23" }}>₹</p>
                            )}
                            &nbsp;
                            {data.title}
                          </div>
                        </Col>
                      </React.Fragment>
                    );
                  })}
                  {this.state.customButtonTip ? (
                    ""
                  ) : (
                    <div
                      className="take-away-order-select ml-3 f12-500"
                      style={{
                        padding: "10px",
                        marginBottom: "8%",
                      }}
                      onClick={this.onCustomTipAccount}
                    >
                      Custom
                    </div>
                  )}
                  {this.state.customButtonTip ? (
                    <div className="col-12 mt-4">
                      <div className="row">
                        <div className="col-8">
                          <NewInputText
                            controlClass={"customButtonTipText"}
                            placeHolder="Enter Amount"
                            type="number"
                            labelText="Enter Amount"
                            variant="outlined"
                            onInput={() => this.maxLengthCheck}
                            maxLength={3}
                            name="customButtonTipText"
                            onChange={this.onHandleChange}
                            value={this.state.customButtonTipText}
                          />
                        </div>
                        <div className="col-4">
                          <button
                            className="btn btn-primary"
                            onClick={
                              this.onClickSaveCustomButtonTips
                            }
                          >
                            Save
                          </button>
                        </div>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                </Row>
              </div>
            </Fragment>}
            {/* <Fragment>
              <hr />
              <div style={{ backgroundColor: "#FFFBEE" }}>
                <div
                  // style={{
                  //   paddingTop: "10px",
                  //   paddingLeft: "10px",
                  // }}
                  className="d-flex justify-content-between pt-2 px-3 align-items-center"
                >
                  <h6>Want to Donate to Smiles?</h6>
                  <VendorLearnMore
                    modalimage={
                      require("../../../../assets/images/udbhav.png")
                        .default
                    }
                    heading="Donate to Udbhav"
                    paragraphText="Udbhav is our projection of help towards the society. Any sizable donation matters. Please donate to help the needy and feed the hunger. Donations will be given to a social cause. We ensure transparency in showing you the records of our donations. Your every penny counts and will be used to save a life!"
                  />
                </div>
                <br />
                <Row
                  // style={{ marginLeft: "3%" }}
                  className="superadmin-orderscomponent-main px-3"
                >
                  {donates.map((data) => {
                    return (
                      <Col
                        xs={4}
                        sm={4}
                        md={4}
                        // className="p-0"
                        align="center"
                        onClick={() =>
                          this.setDonation(data.id, data.amount)
                        }
                        key={data.id}
                      >
                        <div
                          className={`take-away-order-select d-flex f12-500 justify-content-center
                                  ${donationId === data.id &&
                            `take-away-order-select-selected`
                            }`}
                          style={{
                            padding: "10px",
                            marginBottom: "8%",
                          }}
                        >
                          {data.title === "None" ? (
                            ""
                          ) : (
                            <p style={{ color: "#ee3a23" }}>₹</p>
                          )}
                          &nbsp;
                          {data.title}
                        </div>
                      </Col>
                    );
                  })}
                  {this.state.customButtonDonate ? (
                    ""
                  ) : (
                    <div
                      className="take-away-order-select ml-3 f12-500"
                      style={{
                        padding: "10px",
                        marginBottom: "8%",
                      }}
                      onClick={this.onCustomTipDiscountAccount}
                    >
                      Custom
                    </div>
                  )}
                  {this.state.customButtonDonate ? (
                    <div className="col-12 mt-4">
                      <div className="row">
                        <div className="col-8">
                          <NewInputText
                            controlClass={"customButtonDonateText"}
                            placeHolder="Enter Amount"
                            type="number"
                            labelText="Enter Amount"
                            variant="outlined"
                            onInput={() => this.maxLengthCheck}
                            maxLength={3}
                            onKeyPress={(event) => {
                              if (!/[0-9]/.test(event.key)) {
                                event.preventDefault();
                              }
                            }}
                            name="customButtonDonateText"
                            onChange={this.onHandleChange}
                            value={
                              this.state.customButtonDonateText
                            }
                          />
                        </div>
                        <div className="col-4">
                          <button
                            className="btn btn-primary"
                            onClick={
                              this.onClickSaveCustomButtonDonate
                            }
                          >
                            Save
                          </button>
                        </div>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                </Row>
              </div>
            </Fragment> */}

            {(this.props.cart_data.length > 0 && !this.props.history?.location?.state?.hideOffer) ? (
              <div style={{ paddingTop: "5%" }}>
                <h6>Apply Promotions</h6>
                <br />
                <InputPromotion
                  offer_code={this.props.user_data}
                  apply_offer={(code) =>
                    this.checkAndApplyOffer(
                      code,
                      calcTotalOriginal(this.props.cart_data)
                    )
                  }
                />
                <div className="row">
                  <div className="col-12 pt-3 pb-3 d-flex justify-content-end">
                    <button
                      onClick={this.onClickAvailableOffer}
                      className="btn p-0 w-50 f10-500"
                      style={{ color: "#EE3A23" }}
                      type="button"
                    >
                      {this.state.displayAvailableOffers
                        ? "Hide Available Offers"
                        : "Show Available Offers"}
                      <i
                        className={
                          this.state.displayAvailableOffers
                            ? "fa fa-chevron-up ml-2"
                            : "fa fa-chevron-down ml-2"
                        }
                        aria-hidden="true"
                      ></i>
                    </button>
                  </div>
                  <div className="col-12">
                    {this.state.displayAvailableOffers ? (
                      <div className="col-12">
                        {this.state &&
                          this.state.availableOffers.map(
                            (offer, index) => {
                              return (
                                <React.Fragment key={index}>
                                  <div className="row align-items-center">
                                    <div className="col-8 d-flex align-items-center">
                                      <div
                                        className="mr-2"
                                        style={{
                                          width: "35px",
                                          height: "35px",
                                          borderRadius: "50%",
                                        }}
                                      >
                                        <SimpleReactLightbox>
                                          <SRLWrapper
                                            options={optionsImage}
                                          >
                                            <img
                                              alt={offer?.name}
                                              title={offer?.name}
                                              src={
                                                offer?.photo_thumbnails &&
                                                offer
                                                  ?.photo_thumbnails[0]
                                              }
                                              style={{
                                                width: "100%",
                                                height: "35px",
                                                borderRadius: "50%",
                                              }}
                                            />
                                          </SRLWrapper>
                                        </SimpleReactLightbox>
                                      </div>
                                      <p className="f14-500">
                                        {offer?.coupon_code}
                                      </p>
                                    </div>
                                    <div className="col-4">
                                      <i
                                        className="fa fa-clone ml-2"
                                        aria-hidden="true"
                                        onClick={this.copyFunction(
                                          offer
                                        )}
                                      ></i>
                                      <p
                                        className="f9-400 opacity5"
                                        onClick={this.copyFunction(
                                          offer
                                        )}
                                      >
                                        Copy Code
                                      </p>
                                    </div>
                                  </div>
                                  <hr />
                                </React.Fragment>
                              );
                            }
                          )}
                      </div>
                    ) : (
                      <div></div>
                    )}
                  </div>
                </div>
              </div>
            ) : (
              ""
            )}

            <Fragment>
              {this.props.cart_data.length > 0 ? (
                <Fragment>
                  <div style={{ paddingTop: "5%" }}>
                    <h6 className="f18-700">Order Summary</h6>
                    <br />
                    <table style={{ width: "100%" }}>
                      <tbody>
                        <tr>
                          <td>Original Item Value</td>
                          {this.props.cart_data.length > 0 ? (
                            <td style={{ textAlign: "right" }}>
                              ₹{subData.base}
                            </td>
                          ) : (
                            <> </>
                          )}
                        </tr>
                        <tr>
                          <td>Discount</td>
                          {this.props.cart_data.length > 0 ? (
                            <td style={{ textAlign: "right" }}>
                              ₹
                              {
                                this.props.substitute_existing_record.discount?.amount || 0
                              }
                            </td>
                          ) : (
                            <> </>
                          )}
                        </tr>
                        {/* <tr>
                      <td>Substitute Item Value</td>
                      <td>₹450</td>
                    </tr> */}
                        <tr>
                          <td>
                            <div className="d-flex align-items-center">
                              <div>Taxes</div>
                              <InfoToolTip data={subData.taxes.gst} />
                            </div>
                          </td>
                          <td style={{ textAlign: "right" }}>
                            ₹{subData.taxes.gstTotal}
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <div className="d-flex align-items-center">
                              <div>Surcharges</div>
                              <InfoToolTip data={subData.taxes.surCharges} />
                            </div>
                          </td>
                          <td style={{ textAlign: "right" }}>
                            ₹{subData.taxes.surTotal}
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <div className="d-flex align-items-center">
                              <div>Tips</div>
                            </div>
                          </td>
                          <td style={{ textAlign: "right" }}>
                            ₹{this.props.substitute_existing_record.tip?.amount || 0}
                          </td>
                        </tr>
                        <tr>
                          <td colSpan={2}>
                            <hr />
                          </td>
                        </tr>

                        <tr
                          style={{
                            backgroundColor: "#F8F8F8",
                          }}
                        >
                          <td>Previous Order Total</td>
                          <td style={{ textAlign: "right" }}>
                            ₹{this.props.user_data.total_amount}
                          </td>
                        </tr>
                        <hr />
                        <tr>
                          <td>Substitute Item Value</td>
                          <td style={{ textAlign: "right" }}>
                            ₹{cartData?.base}
                          </td>
                        </tr>
                        <tr>
                          <td>Discount</td>
                          <td style={{ textAlign: "right" }}>
                            ₹{" "}
                            {
                              this.props?.history?.location?.state?.discount || this.state.discount
                            }
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <div className="d-flex align-items-center">
                              <div>Taxes</div>
                              <InfoToolTip data={cartData?.taxes?.gst} />
                            </div>
                          </td>
                          <td style={{ textAlign: "right" }}>
                            ₹ {cartData?.taxes?.gstTotal}
                          </td>
                        </tr>
                        <tr>
                          <td>
                            {" "}
                            <div className="d-flex align-items-center">
                              <div>Surcharges</div>
                              <InfoToolTip data={cartData?.taxes?.surCharges} />
                            </div>
                          </td>
                          <td style={{ textAlign: "right" }}>
                            ₹{cartData?.taxes?.surTotal}
                          </td>
                        </tr>
                        <tr>
                          <td>
                            {" "}
                            <div className="d-flex align-items-center">
                              <div>Tips</div>
                            </div>
                          </td>
                          <td style={{ textAlign: "right" }}>
                            ₹{this.props?.history?.location?.state?.tips || this.state.tipAmount}
                          </td>
                        </tr>
                        <tr>
                          <td colSpan={2}>
                            <hr />
                          </td>
                        </tr>
                        <tr
                          style={{
                            backgroundColor: "#F8F8F8",
                          }}
                        >
                          <td>New Order Total</td>
                          <td style={{ textAlign: "right" }}>
                            ₹{allData?.total}
                          </td>
                        </tr>
                        <hr />
                        {/* <tr>
                          <td>Settlement Value</td>
                          <td style={{ textAlign: "right" }}>
                            ₹{allData?.settleAmount}
                          </td>
                        </tr> */}
                        {allData?.pending > 0 && (
                          <tr>
                            <td>Pending Payment</td>
                            <td style={{ textAlign: "right" }}>
                              ₹ {allData.pending}
                            </td>
                          </tr>
                        )}
                        <tr>
                          <td>To Be Paid</td>
                          <td style={{ textAlign: "right" }}>
                            ₹{allData.revisedTotal}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <CreateMemo
                    payment={payment}
                    decidePayment={this.decidePayment}
                    openCreateModal={this.openCreateModal}
                    open_memo_modal={this.state.open_memo_modal}
                  />
                  <div class="mt-3 d-flex">
                    <button
                      type="button"
                      class="onboarding_button_link_reusable onboarding_button_link_reusable_white mr-3"
                      title="Cancel Button"
                      onClick={() => this.props.history.push("/orderdashboard")}
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      class="onboarding_button_link_reusable onboarding_button_link_reusable_red"
                      title="Save Button"
                      onClick={() => {
                        if (this.props.payment) {
                          this.decidePayment(payment);
                        } else {
                          this.openCreateModal();
                        }
                      }}
                    >
                      {"Done"}
                    </button>
                  </div>{" "}
                </Fragment>
              ) : (
                <> </>
              )}
            </Fragment>
            <hr />
          </div>
        )}
        {payment && (
          <PaymentSuccessModel
            open={open}
            props={this.props}
            setOpenTract={this.setOpenTract}
          />
        )}
        {payment && <OrderTrackEntry open={openTract} props={this.props} />}
      </Container>
      //   </React.Fragment>
    );
  }
}

const OrderTrackEntry = (props) => {
  return (
    <React.Fragment>
      <Modal show={props.open} size="md" centered>
        <Modal.Body>
          <h3>Order Success</h3>
          <br />
          <img
            src={require("../../../../assets/images/superadmin/ordericon/success.svg")}
            width="65px"
          />{" "}
          <br />
          <br />
          <b>Your Order has been placed successfully</b>
          <br />
          <div class="mt-3 d-flex">
            <button
              type="button"
              class="onboarding_button_link_reusable onboarding_button_link_reusable_red"
              title="Track Button"
              onClick={() => {
                props.props.history.push("/ordertrack");
              }}
            >
              Track Order
            </button>
            <button
              type="button"
              class="onboarding_button_link_reusable onboarding_button_link_reusable_white mr-3"
              title="Okay"
              onClick={() => {
                // props.props.history.push("/ordertrack");
              }}
            >
              Okay
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
};

const CreateMemo = (props) => {
  return (
    <React.Fragment>
      <Modal show={props.open_memo_modal} size="md" centered>
        <Modal.Header className="border-0" closeButton>
          <Modal.Title className="f24_700_HelveticaNeue">
            Create Memo
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="f12-500 mb-2">
            Please Create the credit memo for the substituted Item
          </div>
          <div class="mt-3 d-flex">
            <button
              type="button"
              class="onboarding_button_link_reusable onboarding_button_link_reusable_white mr-3"
              title="Cancel Button"
              onClick={() => props.openCreateModal()}
            >
              Cancel
            </button>
            <button
              type="button"
              class="onboarding_button_link_reusable onboarding_button_link_reusable_red"
              title="Save Button"
              onClick={() => {
                props.openCreateModal();
                props.decidePayment(props.payment);
              }}
            >
              {"Done"}
            </button>
          </div>{" "}
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
};
const PaymentSuccessModel = (props) => {
  const [success, setSuccess] = React.useState(false);
  return (
    <React.Fragment>
      <Modal show={props.open} size="md" centered>
        {/* <Modal.Header className="border-0" closeButton> */}
        {/* <Modal.Title className="f24_700_HelveticaNeue">
              Edit Customer Details
            </Modal.Title> */}
        {/* </Modal.Header> */}
        <Modal.Body>
          <div style={{ backgroundColor: "#FFFBEE", padding: "15px" }}>
            <div className="row">
              <div className="col-6">
                Order ID: <span style={{ color: "#F85032" }}>214536878</span>
              </div>
              <div className="col-6" align="right">
                <span className="badge badge-warning">Take Away</span>
              </div>
            </div>

            <h1>Payment {success ? "Success" : "Failed"}</h1>
            <Row>
              <Col xs={2}>
                <img
                  src={require(`../../../../assets/images/superadmin/ordericon/${success ? `success` : `failed`
                    }.svg`)}
                  width="45px"
                  heigth="15px"
                />{" "}
              </Col>
              <Col xs={10} style={{ paddingTop: "10px" }}>
                {success
                  ? "Your payment has been successfully made"
                  : "Your payment has been declined"}
              </Col>
            </Row>
          </div>
          <hr />
          <div style={{ backgroundColor: "#F3F3F3", padding: "15px" }}>
            Transaction ID :{" "}
            <span style={{ color: "#F85032" }}>12467867564</span>
            <br />
            <Row>
              <Col xs={6}>
                <b>29th August 2019 </b>
                <br />
                <span style={{ color: "#757575" }}>Date</span>
              </Col>
              <Col xs={6}>
                <b>09:30 PM </b>
                <br />
                <span style={{ color: "#757575" }}>Time</span>
              </Col>
            </Row>
          </div>
          <br />
          <div style={{ backgroundColor: "#F3F3F3", padding: "15px" }}>
            <table style={{ width: "100%" }}>
              <tbody>
                <tr>
                  <td>
                    <b>Sub Total</b>
                  </td>
                  <td>
                    <b>₹800</b>
                  </td>
                </tr>
                <tr>
                  <td>Tip</td>
                  <td>₹20</td>
                </tr>
                <tr>
                  <td>Donation (10%)</td>
                  <td>₹20</td>
                </tr>

                <tr
                  style={{
                    backgroundColor: "#F8F8F8",
                  }}
                >
                  <td style={{ paddingTop: "5px", paddingBottom: "5px" }}>
                    <b>Paid</b>
                  </td>
                  <td style={{ paddingTop: "5px", paddingBottom: "5px" }}>
                    <b>₹895.00</b>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <hr />
          <button
            type="button"
            class="onboarding_button_link_reusable onboarding_button_link_reusable_red w-100"
            title="Done"
            onClick={() => {
              props.setOpenTract();
            }}
          >
            Done
          </button>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
  onboarding: state.onboarding.restaurantDetails,
  subscription: state.onboarding.onboard_subscription_details,
  cart_data: state.vendorOrdering.vendor_cart_data,
  user_data: state.vendorOrdering.vendor_order_data,
  item: state.vendorOrdering.substitute_item_data,
  substitute_existing_record: state.vendorOrdering.substitute_existing_record,
  offerData: state.offersevents.vendor_all_offers,
});

export default withRouter(
  connect(mapStateToProps, {
    create_order_vedor_side,
    razor_pay_create_order,
    razor_payment,
    credit_memo_substitute_item,
    substitute_items,
    debit_memo_order_substitute_item,
    editTransaction,
    apply_offer_code,
    get_offers_details
  })(RightComponentOrderRequestSubstitute)
);
